import styled from "styled-components";
import { Body60, H1, H3 } from "../../styles/stringStyles";

type Props = {
  headline?: string;
  text?: string[];
  preHeadline?: string;
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
};

export const InfoText = ({
  preHeadline,
  headline,
  text,
  ref,
  className,
}: Props) => {
  return (
    <Container ref={ref} className={className}>
      {preHeadline && <StyledH3>{preHeadline}</StyledH3>}
      <H1>{headline}</H1>
      {text && (
        <div>
          {text?.map((text, index) => (
            <Body60 key={index}>{text}</Body60>
          ))}
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const StyledH3 = styled(H3)`
  opacity: 0.6;
`;
